<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g class="fill-current">
      <path
        d="M26.579 5.982l-5.12-5.12c-0.529-0.531-1.261-0.861-2.070-0.862h-12.46c-1.618 0.005-2.928 1.317-2.93 2.936v25.394c0.001 1.618 1.312 2.929 2.93 2.93h17.581c1.618-0.001 2.929-1.312 2.93-2.93v-20.272c-0.001-0.81-0.33-1.544-0.861-2.075l0 0zM25.2 7.36c0.122 0.121 0.211 0.273 0.255 0.445l0.001 0.007h-5.829v-5.821c0.178 0.045 0.331 0.134 0.451 0.256l0 0zM24.51 29.298h-17.581c-0.538-0.002-0.974-0.438-0.976-0.976v-25.386c0.002-0.538 0.438-0.974 0.976-0.976h10.744v6.347c0 0.001 0 0.003 0 0.005 0 0.807 0.654 1.461 1.461 1.461 0.002 0 0.003 0 0.005 0h6.349v18.56c-0.004 0.537-0.44 0.972-0.977 0.973h-0zM21.579 14.411v0.488c-0.001 0.404-0.328 0.732-0.733 0.733h-10.255c-0.404-0.001-0.732-0.328-0.733-0.733v-0.488c0.001-0.404 0.328-0.732 0.733-0.733h10.256c0.404 0.002 0.73 0.329 0.731 0.733v0zM21.579 18.318v0.488c-0.001 0.404-0.328 0.732-0.733 0.733h-10.255c-0.404-0.001-0.732-0.328-0.733-0.733v-0.488c0.001-0.404 0.328-0.732 0.733-0.733h10.256c0.404 0.002 0.73 0.329 0.731 0.733v0zM21.579 22.226v0.494c-0.001 0.404-0.328 0.732-0.733 0.733h-10.255c-0.404-0.001-0.732-0.328-0.733-0.733v-0.488c0.001-0.404 0.328-0.732 0.733-0.733h10.256c0.401 0.002 0.727 0.325 0.731 0.726v0z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
